import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { WarningIcon } from 'common/icons';
import { staticStyles } from './style';

const TransferWarning = ({ warningTextId }) => (
  <div className="TransferWarning">
    <div className="TransferWarning__icon-wrapper">
      <WarningIcon />
    </div>
    <FormattedMessage id={warningTextId} />
    <style jsx global>
      {staticStyles}
    </style>
  </div>
);

TransferWarning.propTypes = {
  warningTextId: PropTypes.string.isRequired,
};

export default TransferWarning;
